import React, { useState, useEffect} from "react";
import "./Profile.css"
import verificato from "../../media/badge.png";
import userApi from "../../HTTP/user"
import ReviewBlocks from '../Review/ReviewBlocks'; // Assurez-vous que le chemin d'importation est correct
import { useParams } from 'react-router-dom';
import { getArticlesByAuthorId, addFavorite, removeFavorite } from "../../HTTP/articles";
import { sendArticleReadNotification } from "../../HTTP/user";
import { formatDateExtended, goToStaticPage, removeHtmlTags } from "../../Helper/utils";
import Pagination from "../../Helper/Pagination";
import imgArticle from "../../media/ICONS THEMATIQUE/Fichier 5_1.png"
import { countries } from "../../global/countriesAndSources";
import { getIgo } from "../../HTTP/translation";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import RecommendToFriendPopup from "../Common/RecommendToFriendPopup";
import ProfileFeedSection from "./ProfileFeedSection";
import ProfileSelfActions from "./ProfileSelfActions";
import IgoFavoritesButton from "../Common/IgoFavoritesButton";
import { recordView } from "../../HTTP/stats";

const UserProfile = ({ userId }) => {
	const params = useParams();
	const id = userId ?? params.id;
	const [profileUser, setProfileUser] = useState({});
	const [profileError, setProfileError] = useState(null);
	const [country, setCountry] = useState('Non défini');
	const user = JSON.parse(localStorage.getItem('user'));
	const [friendStatus, setFriendStatus] = useState("loading");
	const [isSendingInvite, setIsSendingInvite] = useState(false);
	const isSelfProfile = user && String(user.id) === String(id);
	const [allIgo, setAllIgo] = useState([]);
	const [profileIgoIds, setProfileIgoIds] = useState(new Set());
	const [viewerIgoIds, setViewerIgoIds] = useState(new Set());
	const [igoLoading, setIgoLoading] = useState(false);
	const [followBusy, setFollowBusy] = useState({});

	const url = new URL(window.location.href)
	if (url.searchParams.get('articlepage') === null) {
		url.searchParams.set('articlepage', 1);
		window.history.pushState({}, '', url);
	}
	
	useEffect(() => {
		setProfileError(null);
		setProfileUser({});
		userApi.getUserProfile(id).then((profile) => {
			if (!profile || typeof profile !== "object" || profile.statusCode >= 400) {
				throw new Error("Réponse de profil invalide");
			}
			setProfileUser(profile);
			if (user && String(user.id) !== String(id)) {
				recordView("profile", id).catch(() => {});
			}
			if (profile?.country !== null && profile?.country !== undefined) {
				const c = countries.find((c) => c.code === profile.country);
				if (c) setCountry(c.name);
			}
		}).catch((error) => {
			setProfileUser({});
			setProfileError({ status: error?.status, message: error?.message });
		})
	}, [id]);

	useEffect(() => {
		let isMounted = true;
		const fetchFriendStatus = async () => {
			try {
				const [friends, invitations, requests] = await Promise.all([
					userApi.getAllFriends(),
					userApi.getInvitations(),
					userApi.getFriendRequests(),
				]);
				if (!isMounted) return;
				const friendId = parseInt(id, 10);
				const isFriend = Array.isArray(friends) && friends.some((f) => f.id === friendId);
				const isInvited = Array.isArray(invitations) && invitations.some((f) => f.id === friendId);
				const isRequested = Array.isArray(requests) && requests.some((f) => f.id === friendId);
				if (isFriend) {
					setFriendStatus("friend");
				} else if (isInvited) {
					setFriendStatus("invited");
				} else if (isRequested) {
					setFriendStatus("requested");
				} else {
					setFriendStatus("not_friend");
				}
			} catch (error) {
				console.error("Erreur lors de la récupération du statut d'ami", error);
				if (isMounted) setFriendStatus("unknown");
			}
		};
		fetchFriendStatus();
		return () => {
			isMounted = false;
		};
	}, [id]);

	const [reviews, setReviews] = useState([]); 
	const [articles, setArticles] = useState({count:0, rows:[]});
	const [currentArticlePage, setCurrentArticlePage] = useState(parseInt(url.searchParams.get('articlepage')));
	const [activeSection, setActiveSection] = useState("favorites");
	const [selectedArticleIdForRecommendation, setSelectedArticleIdForRecommendation] = useState(null);

	const isPrivateProfilePayload = (() => {
		if (String(profileUser?.private) !== "1" && profileUser?.private !== true) return false;
		const fieldsToCheck = [
			profileUser?.firstname,
			profileUser?.lastname,
			profileUser?.email,
			profileUser?.phone,
			profileUser?.address,
			profileUser?.bio,
			profileUser?.country,
			profileUser?.profile_picture,
		];
		return fieldsToCheck.every((value) => value === null || value === undefined || value === "");
	})();
	const isPrivateProfile = isPrivateProfilePayload && friendStatus !== "friend";
	const isPrivateProfileBlocked = isPrivateProfile && !isSelfProfile;

	const normalizeIgoIds = (res) => {
		const list = Array.isArray(res)
			? res
			: Array.isArray(res?.data)
			? res.data
			: Array.isArray(res?.items)
			? res.items
			: typeof res?.igo_id_list === "string"
			? res.igo_id_list.split(",").map((entry) => entry.trim())
			: [];
		return new Set(
			list
				.map((item) => item?.igo_id ?? item?.igoId ?? item?.id ?? item?.igo?.id ?? item)
				.filter(Boolean)
				.map((value) => String(value))
		);
	};

	useEffect(() => {
		if (isPrivateProfileBlocked) return;

		let alive = true;
		const loadIgoData = async () => {
			setIgoLoading(true);
			try {
				const [igoList, profileIgoRes, viewerIgoRes] = await Promise.all([
					getIgo(),
					userApi.getIgoFromUser(id),
					user?.id ? userApi.getIgoFromUser(user.id) : Promise.resolve([]),
				]);
				if (!alive) return;
				setAllIgo(Array.isArray(igoList) ? igoList : []);
				setProfileIgoIds(normalizeIgoIds(profileIgoRes));
				setViewerIgoIds(normalizeIgoIds(viewerIgoRes));
			} catch (err) {
				console.error("Erreur lors du chargement des OIG", err);
				if (!alive) return;
				setAllIgo([]);
				setProfileIgoIds(new Set());
				setViewerIgoIds(new Set());
			} finally {
				if (alive) setIgoLoading(false);
			}
		};

		loadIgoData();
		return () => {
			alive = false;
		};
	}, [id, user?.id, isPrivateProfileBlocked]);

	useEffect(() => {
		if (isPrivateProfileBlocked) return;
		const fetchReviews = async () => {
		  const reviewsData = await userApi.getUserReviews(id); // Assurez-vous que ceci renvoie un tableau 
		  setReviews(reviewsData.reviews);
		};
	  
		fetchReviews();
	  }, [id, isPrivateProfileBlocked]);
	
	useEffect(() => {
		if (isPrivateProfileBlocked) return;
		const fetchArticles = async () => {
			const articlesData = await getArticlesByAuthorId(id, (currentArticlePage - 1) * 3, currentArticlePage * 3, "" , "title", 4);
			console.log(articlesData)
			setArticles(articlesData);
		  }
		  fetchArticles();
	}, [currentArticlePage, id, isPrivateProfileBlocked]);

	console.log(articles)

	const [favorites, setFavorites] = useState(JSON.parse(localStorage.getItem('favorites') || []));

	const profileIgoList = allIgo.filter((item) => profileIgoIds.has(String(item.id)));

	const isViewerFollowing = (igoId) => viewerIgoIds.has(String(igoId));

	const toggleFollowIgo = async (igoId, shouldFollow) => {
		if (!user?.id || !igoId) return;
		const normalizedId = String(igoId);
		setFollowBusy((prev) => ({ ...prev, [normalizedId]: true }));
		try {
			const ok = shouldFollow
				? await userApi.addIgoToUser(user.id, igoId)
				: await userApi.deleteIgoFromUser(user.id, igoId);
			if (!ok) return;
			setViewerIgoIds((prev) => {
				const next = new Set(prev);
				if (shouldFollow) {
					next.add(normalizedId);
				} else {
					next.delete(normalizedId);
				}
				return next;
			});
		} catch (err) {
			console.error("Erreur lors du suivi de l'OIG", err);
		} finally {
			setFollowBusy((prev) => ({ ...prev, [normalizedId]: false }));
		}
	};

  const handleArticleToFavorite = async (id, title, link, image, country, date, description) => {
    const favorite = {
      title: title,
      link: link,
      image: image || "",
      country: user.country,
      publication_date: date,
      description: description
    };

    try {
      const res = await addFavorite(favorite);
      if (res.ok === true) {
        favorite.id = res.id;
        const updatedFavorites = [favorite, ...favorites];
        setFavorites(updatedFavorites);
        localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
        alert('Article added to favorites !');
      }
    } catch (error) {
      console.error('An error has occured when adding the favorite', error);
      alert('An error has occured when adding the favorite');
    }
  };

  const handleRemoveFromFavorite = async (link) => {
    try {
      const res = await removeFavorite({ link });
      if (res) {
        console.log(favorites)
        const updatedFavorites = favorites.filter(fav => fav.link !== link);
        console.log(updatedFavorites)
        setFavorites(updatedFavorites);
        localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
        alert('Article removed from favorites !');
      }
    } catch (error) {
      console.error('An error has occured when deleting the favorite', error);
      alert('An error has occured when deleting the favorite');
    }
  };

  const handleSendArticleNotification = async (friendId) => {
	if (!selectedArticleIdForRecommendation || !friendId) return false;
	const res = await sendArticleReadNotification(selectedArticleIdForRecommendation, friendId);
	if (res) {
	  alert("Notification envoyee");
	  return true;
	}
	alert("Erreur lors de l'envoi de la notification");
	return false;
  };

  const ArticleCard = ({ articleId, imageUrl, author, authorProfilePicture, authorId, title, text, date }) => {
	console.log(imageUrl)
    const articleLink = `https://static.zemus.info/article/?id=${articleId}&readerid=${user.id}`;
    const isFavorite = favorites.some(fav => fav.link === articleLink);

    const handleFavoriteClick = () => {
      if (isFavorite) {
        handleRemoveFromFavorite(articleLink);
      } else {
        handleArticleToFavorite(
		  articleId,
          title,
          articleLink,
          imageUrl,
          user.country,
          new Date().toISOString().replace("T", " ").slice(0, 19),
          text.length > 150 ? text.slice(0, 50) + "..." : text
        );
      }
    };

    return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden transition duration-300 ease-in-out transform hover:-translate-y-1 hover:shadow-xl h-full">
      <div className="flex flex-col h-full">
      <button onClick={() => goToStaticPage(true, articleId)}>
        <img
          className="w-full h-48 object-cover flex-shrink-0"
          src={imageUrl ? imageUrl : imgArticle}
          alt={title}
        />
      </button>
        <div className="p-4 flex-grow flex flex-col">
          <button onClick={() => goToStaticPage(true, articleId)} className="flex flex-col flex-grow">
            <h3 className="text-lg font-semibold mb-2">{title}</h3>
            <p className="text-gray-600 flex-grow">
              {text.length > 150 ? text.slice(0, 50) + "..." : text}
            </p>
          </button>
          <div className="flex items-center mb-2">
            <a href={`/friends/${authorId}`} className="flex items-center space-x-2">
              <img
                className="w-8 h-8 rounded-full mr-2"
                src={authorProfilePicture || process.env.PUBLIC_URL+"/profile_default.png"}
                alt="profile_picture_author"
              />
              <p className="text-sm mt-2 notranslate">
                {author}
              </p>
            </a>
            <p className="text-sm mt-2 ml-2 notranslate">
              {formatDateExtended(date)}
            </p>
            <button 
			  type="button"
			  onClick={() => setSelectedArticleIdForRecommendation(articleId)}
			  className="ml-auto focus:outline-none"
			>
			  <ArrowOutwardIcon />
			</button>
            <button 
			  type="button"
              onClick={handleFavoriteClick}
              className="focus:outline-none"
            >
            <img 
              className="w-6 h-6 ml-2" 
              src={process.env.PUBLIC_URL + (isFavorite ? "/bookmark.svg" : "/bookmarklight.svg")} 
              alt="favoris"
            />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

	const articlePagination = (pageNumber) => {
		url.searchParams.set('articlepage', pageNumber);
		window.history.pushState({}, '', url);
		setCurrentArticlePage(pageNumber);
	}

	const handleSendInvitation = async () => {
		try {
			setIsSendingInvite(true);
			await userApi.addFriend(id);
			setFriendStatus("invited");
		} catch (error) {
			console.error("Erreur lors de l'envoi de l'invitation", error);
		} finally {
			setIsSendingInvite(false);
		}
	};

	const friendStatusLabel = (() => {
		switch (friendStatus) {
			case "friend":
				return "Ami";
			case "invited":
				return "Invitation envoyée";
			case "requested":
				return "Invitation reçue";
			case "not_friend":
				return "Pas encore ami";
			default:
				return "Statut indisponible";
		}
	})();

	const displayName = isPrivateProfile
		? "Utilisateur privé"
		: `${profileUser?.firstname || ""} ${profileUser?.lastname || ""}`.trim() || "Utilisateur";
	const canAccessProfileFeed = isSelfProfile || friendStatus === "friend";

	if (profileError) {
		const isPrivateProfileError = profileError.status === 403;
		const errorMessage = isPrivateProfileError
			? profileError.message || "Ce profil est privé"
			: profileError.status === 404
				? profileError.message || "Ce profil n'existe pas"
				: "Impossible de charger le profil. Merci de réessayer plus tard.";

		return (
			<div className="profileContainer">
				<h1 className="ml-4 mt-4 mb-2">{isPrivateProfileError ? "Profil privé" : "Profil indisponible"}</h1>
				<p className="ml-4 mb-4">{errorMessage}</p>
				{isPrivateProfileError && !isSelfProfile && friendStatus === "not_friend" && (
					<button
						type="button"
						className="ml-4 p-2 shadow-sm transition-colors rounded bg-white text-zemusbis border border-zemusbis"
						onClick={handleSendInvitation}
						disabled={isSendingInvite}
					>
						{isSendingInvite ? "Envoi..." : "Envoyer une invitation"}
					</button>
				)}
			</div>
		);
	}

	if (isPrivateProfileBlocked) {
		return (
			<div className="profileContainer">
				<h1 className="ml-4 mt-4 mb-2">Profil privé</h1>
				<p className="ml-4 mb-4">
					Ce profil est privé. Vous devez être ami avec cet utilisateur pour le consulter.
				</p>
			</div>
		);
	}

	return (
		<div>
		<div
			className="profileHeader md:flex md:mt-8"
			style={profileUser.banner ? {
				backgroundImage: `linear-gradient(rgba(0,0,0,0.35), rgba(0,0,0,0.35)), url(${profileUser.banner})`,
				backgroundSize: "cover",
				backgroundPosition: "center",
			} : undefined}
		>
			<div className="profileHeader-element">  
				<img src={profileUser.profile_picture || process.env.PUBLIC_URL+"/profile_default.png" } alt="profile" className="profilePicture" />  
			</div>
			<div className="profileHeader-element">  
			<h2 className="notranslate"> 
				{ displayName }
				<img className="verificato" src={verificato} alt="verification" />
			</h2>
				<div className="md:flex">
					{
						profileUser.phone !== null && profileUser.phone !== "" && (
							<p className="notranslate"><img src={process.env.PUBLIC_URL+"/sidebar/tel.png"} alt="Phone" className="profilePicto"  />{ `${profileUser?.phone}` }</p>
						)
					}
					{
						profileUser.email !== null && profileUser.email !== "" && (
							<p className="notranslate"><img src={process.env.PUBLIC_URL+"/sidebar/mail_white.png"} alt="email" className="profilePicto" />{ `${profileUser?.email}` }</p>
						)
					}
				</div>
				<p><img src={process.env.PUBLIC_URL+"/sidebar/terre.png"} alt="Country" className="profilePicto"  />{ `${country}` }</p>
				{!isSelfProfile && (
					<div className="mt-2 flex items-center">
						<p className="mr-3">Statut : {friendStatusLabel}</p>
						{friendStatus === "not_friend" && (
							<button
								type="button"
								className="p-2 shadow-sm transition-colors rounded bg-white text-zemusbis border border-zemusbis"
								onClick={handleSendInvitation}
								disabled={isSendingInvite}
							>
								{isSendingInvite ? "Envoi..." : "Envoyer une invitation"}
							</button>
						)}
					</div>
				)}
				{
					profileUser.address !== null && profileUser.address !== "" && (
						<p><img src={process.env.PUBLIC_URL+"/sidebar/pin.png"} alt="Address" className="profilePicto"  />{ `${profileUser?.address}` } </p>  
					)
				}  
			</div> 
			{
				profileUser.bio !== null && profileUser.bio !== "" && (
					<div className="profileHeader-element">  
						<div className="mt-2 pl-5 pr-5 md:ml-5 border-l-2 border-white profileHeader-bio">
							<h3 className="font-bold mb-2">Biographie</h3>
							<p>{ `${profileUser?.bio}` } </p>
						</div>
					</div>
				)
			}
			{isSelfProfile && <ProfileSelfActions user={user} />}
		</div>
		{!isPrivateProfile && (
		<div className="w-full flex justify-center flex-row p-2 notranslate" translate="no">
        <button
          type="button"
          style={{ backgroundColor: activeSection === "favorites" ? '#c3e5ef' : "#009aad", color: activeSection === "favorites" ? "black" : "white"}}
          className="w-full md:mr-4 mb-4 md:mb-0 p-2 shadow-sm transition-colors rounded mr-1"
          onClick={() => setActiveSection("favorites")}
          >
            Favoris partagés
        </button>
        <button
          type="button"
          style={{ backgroundColor: activeSection === "articles" ? '#c3e5ef' : "#009aad", color: activeSection === "articles" ? "black" : "white" }}
          className="w-full md:mr-4 mb-4 md:mb-0 p-2 shadow-sm transition-colors rounded mr-1"
          onClick={() => setActiveSection("articles")}
          >
            Articles publiés
        </button>
		<button
          type="button"
          style={{ backgroundColor: activeSection === "igo" ? '#c3e5ef' : "#009aad", color: activeSection === "igo" ? "black" : "white" }}
          className="w-full mb-4 md:mb-0 p-2 shadow-sm transition-colors rounded"
          onClick={() => setActiveSection("igo")}
          >
            Forums suivis
        </button>
		{canAccessProfileFeed && (
			<button
			  type="button"
			  style={{ backgroundColor: activeSection === "profile_feed" ? '#c3e5ef' : "#009aad", color: activeSection === "profile_feed" ? "black" : "white" }}
			  className="w-full mb-4 md:mb-0 p-2 shadow-sm transition-colors rounded ml-1"
			  onClick={() => setActiveSection("profile_feed")}
			  >
				Ma sélection
			</button>
		)}
      </div>
		)}
		{!isPrivateProfile && (
		<div key={activeSection}>
		{
			activeSection === "favorites" ? (
				<div className='profileContainer'> 
					<h1 className="ml-4 mt-4 mb-4 notranslate" translate="no">Favoris partagés</h1> 
					<div className="ml-4 mr-4">
						<ReviewBlocks reviews={reviews} edition="false" displayAuthor={false} favorites={favorites} handleAddFav={handleArticleToFavorite} handleRemFav={handleRemoveFromFavorite} />
					</div>
				</div>
			) : activeSection === "articles" ? (
				<>
					<div className='profileContainer'>
						<h1 className="ml-4 mt-4 mb-4 notranslate" translate="no">Articles publiés</h1>
						<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
							{articles.rows.map((article, i) => (
								<ArticleCard
									key={i}
									articleId={article.id}
									imageUrl={article.image}
									title={article.title}
									text={removeHtmlTags(article.description)}
									date={article.created_at}
								/>
							))}
						</div>
					</div>
					<Pagination
						itemsPerPage={3}
						totalItems={articles.count}
						paginate={articlePagination}
						currentPage={currentArticlePage}
					/>
				</>
			) : activeSection === "profile_feed" && canAccessProfileFeed ? (
				<ProfileFeedSection
					profileUserId={id}
					currentUserId={user?.id}
					canView={true}
					canPost={true}
					title="Ma sélection"
				/>
			) : (
				<div className="profileContainer">
					<h1 className="ml-4 mt-4 mb-4 notranslate" translate="no">
						{`Forums suivis ${isSelfProfile ? "par vous" : "par cet utilisateur"}`}
					</h1>
					{igoLoading ? (
						<p className="ml-4 mb-4">Chargement des Forums suivis…</p>
					) : profileIgoList.length === 0 ? (
						<p className="ml-4 mb-4">Aucun Forum suivi pour le moment.</p>
					) : (
						<div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 ml-4 mr-4 mb-4">
							{profileIgoList.map((igoItem) => {
								const igoId = igoItem.id ?? igoItem.igo_id ?? igoItem.igoId;
								return (
									<div key={igoId} className="bg-white rounded-lg shadow p-4">
									<div className="flex items-center gap-3">
										<img
											className="w-12 h-12 mr-3 object-contain"
											src={igoItem.image || process.env.PUBLIC_URL + "/favicon.png"}
											alt={igoItem.label || igoItem.name}
										/>
										<div className="flex-1">
											<p className="font-semibold">{igoItem.label || igoItem.name}</p>
										</div>
										{user?.id && igoId && (
											<button
												type="button"
												className={
													isViewerFollowing(igoId)
														? "border-2 border-red-500 text-red-600 px-3 py-1 rounded text-sm"
														: "border-2 border-cyan-600 text-cyan-700 px-3 py-1 rounded text-sm"
												}
												disabled={followBusy[String(igoId)]}
												onClick={() => toggleFollowIgo(igoId, !isViewerFollowing(igoId))}
											>
												{isViewerFollowing(igoId) ? "Ne plus suivre" : "Suivre"}
											</button>
										)}
									</div>
									{igoId && (
										<div className="mt-3">
											<IgoFavoritesButton igoId={igoId} igoName={igoItem.label || igoItem.name} userId={id} />
										</div>
									)}
									</div>
								);
							})}
						</div>
					)}
				</div>
			)
		}
		</div>
		)}
		<RecommendToFriendPopup
			isOpen={selectedArticleIdForRecommendation !== null}
			onClose={() => setSelectedArticleIdForRecommendation(null)}
			onConfirm={handleSendArticleNotification}
			title="Recommander à un ami"
		/>
		</div>
	)
}

export default UserProfile
